import React, { useState, useEffect } from "react";
import App from "./App";
import ConfigContext from "./contexts/ConfigContext";
import axios from "axios";

function AppLoader() {
  const [config, setConfig] = useState(null);
  const [isConfigLoaded, setIsConfigLoaded] = useState(false);

  useEffect(() => {
    (async () => {
      if (config == null) {
            await axios
            .get("config.json")
            .then(function (response) {
                setConfig(response.data);
                setIsConfigLoaded(true);
            })
            .catch(function (error) {
                console.log("Could not load application configuration.");
                console.log(error);
            });
        }
      })();
    }, []);

  return (
    isConfigLoaded && (
      <ConfigContext.Provider value={config}>
        <App />
      </ConfigContext.Provider>
    )
  );
}

export default AppLoader;